import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";          // ← add this

const firebaseConfig = {
  apiKey: "AIzaSyByyIb5lycLZznmHm3FVIy8IYInUzo30AY",
  authDomain: "we-study-43745.firebaseapp.com",
  projectId: "we-study-43745",
  appId: "1:824953922910:web:3c0dc100461559d05adbcf",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);                 // ← add this
